import { Button, Modal, Spacer, Text } from '@oy/uidesktop';
import { useTranslate } from 'src/hooks';

export const AlreadySignedModal = ({
  showModal,
  onCloseModal,
}: {
  showModal: boolean;
  onCloseModal: () => void;
}) => {
  const { getTranslation } = useTranslate();
  return (
    <Modal
      show={showModal}
      onClose={onCloseModal}
      style={{ width: '480px' }}
      closeOnBackdropClick
    >
      <Modal.Body>
        <Text textStyle={Text.Style.BodyLgRegular}>
          {getTranslation('tickbox_description_already_signed_1')}
        </Text>
        <Spacer top={Spacer.Size.M} />
        <Text textStyle={Text.Style.BodyLgRegular}>
          {getTranslation('tickbox_description_already_signed_2')}
          <a href={`mailto:${import.meta.env.VITE_KYB_EMAIL}`}>
            {import.meta.env.VITE_KYB_EMAIL}
          </a>
        </Text>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={onCloseModal} fullWidth>
          {getTranslation('common_gotIt')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
